export default __webpack_public_path__ + "static/media/image4-3.98c37683.png";